export const PRICE_PER_HALF_HOUR = 15;
